import { AnimatePresence, motion } from "framer-motion";
import type { Match, Player } from "../types";

interface MatchHistoryProps {
	matches: Match[];
	players: Player[];
	onViewAll?: () => void;
}

export function MatchHistory({
	matches,
	players,
	onViewAll,
}: MatchHistoryProps) {
	const getPlayerName = (id: string) => {
		return players.find((p) => p.id === id)?.name ?? "Unknown";
	};

	const formatTime = (timestamp: number) => {
		const date = new Date(timestamp);
		return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
	};

	const recentMatches = matches.slice(0, 10);

	if (recentMatches.length === 0) {
		return (
			<div className="card match-history">
				<h2>Recent Matches</h2>
				<p className="hint">No matches recorded yet.</p>
			</div>
		);
	}

	return (
		<div className="card match-history">
			<h2>Recent Matches</h2>
			<div className="match-list">
				<AnimatePresence mode="popLayout">
					{recentMatches.map((match) => {
						const eloChange = match.winnerEloAfter - match.winnerEloBefore;
						return (
							<motion.div
								key={match.id}
								layout
								initial={{ opacity: 0, x: -20 }}
								animate={{ opacity: 1, x: 0 }}
								exit={{ opacity: 0, x: 20 }}
								transition={{ duration: 0.2 }}
								className="match-item"
							>
								<span className="time">{formatTime(match.timestamp)}</span>
								<div className="match-result">
									<span className="winner">
										{getPlayerName(match.winnerId)}
									</span>
									<span className="vs">beat</span>
									<span className="loser">{getPlayerName(match.loserId)}</span>
								</div>
								<span className="elo-change">±{eloChange}</span>
							</motion.div>
						);
					})}
				</AnimatePresence>
			</div>
			{onViewAll && matches.length > 0 && (
				<button type="button" className="view-all-link" onClick={onViewAll}>
					View all matches
				</button>
			)}
		</div>
	);
}
